






























































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/lineGraph.js"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";

@Component({
    components : {
        ripple,
        gbutton,
        graph,
        tooltip,
    },
})
export default class Updates extends Vue{
    perc:number = 0;

    mounted(){
       this.$emit('scope','home');
    }

    gae(){
        let a:Array<any> = [24, 14, 20, 26, 0, 17, 4, 26, 6, 0, 4, 26, 1, 14, 24];
        let alphabet:Array<any> = "abcdefghijklmnopqrstuvwxyz".split('');
        let string:string = '';
        for(let i = 0; i< a.length; i++){
            if(!alphabet[a[i]]){
                string += " ";
            }else{
                string += alphabet[a[i]];
            }
        }
    }
    encode(string){
        let a:Array<any> = [];
        let alphabet:Array<any> = "abcdefghijklmnopqrstuvwxyz".split('');
        for(let i = 0; i< string.length; i++){
            if(string[i] == ' '){
                a.push(26);
            }else{
                a.push(alphabet.indexOf(string[i]));
            }
        }
    }
}
